module.exports = __webpack_public_path__ + "img/mussels-blacktable-1600x800.4c3e325c.jpg";